import { forwardRef } from 'react'
import { Dialog, Slide, Box, Typography} from "@mui/material";
import { useStyles } from './NewClientsPopup.styles';
import CloseIcon from '@mui/icons-material/Close';
import WhatsappIcon from '../../assets/whatsappWhiteIcon.webp'
import VillanuevaIcon from '../../assets/logo_VN_blanco.png'
import NewClientPopupBackground from '../../assets/newClientPopup2.png'
// import NewClientsPopupBackground from './background';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

const whatsappChatUrl = 'https://api.whatsapp.com/send?phone=5493534250771'

export default function NewClientPopup2 ({ isOpen = false, onClose }) {
  const styles = useStyles()

  return (
    <Dialog
      open={isOpen}
      onClose={() => {}}
      TransitionComponent={Transition}
    >
      <div style={{ display: 'flex', alignItems:'center', overflow: 'hidden', maxWidth: 400 }}>
        <div style={{ position: 'absolute', top: 10, right: 10 }}>
          <CloseIcon sx={{ color: 'white', cursor:'pointer' }} onClick={onClose} />
        </div>
        <img src={NewClientPopupBackground} style={{width: '100%'}}/>
        <Box 
          onClick={() => window.open(whatsappChatUrl, '_blank') }
          sx={{
            position: 'absolute',
            // backgroundColor: 'red',
            cursor: 'pointer',
            height: '40px',
            width: '340px',
            bottom: '85px',
            left: 0,
            right: 0, 
            marginLeft: 'auto',
            marginRight: 'auto', 
          }}
        />
      </div>
      {/* <Box className={styles.container}>
        <Box className={styles.closeButtonContainer}>
          <CloseIcon sx={{ color: 'white', cursor:'pointer' }} onClick={onClose} />
        </Box>
        <Box className={styles.boxWithMargin}>
          <Box className={styles.titleContainer}>
            <Typography className={styles.whiteText}>¡Bienvenido a la nueva tienda</Typography>
            <Typography className={styles.whiteText}>online VILLANUEVA!</Typography>
          </Box>
          <Box className={styles.escribenosContainer}>
            <Typography className={styles.whiteText}>
              Podras iniciar sesión 
              <Typography>
                con los nuevos datos que te llegaron
              </Typography>
              <Typography>
                via email a la casilla que tenes registrada
              </Typography>
            </Typography>
          </Box>
        </Box>
        <Box className={styles.dividerContainer}>
          <Typography className={styles.blackText}>
            En caso de no haber recibido esta información
          </Typography>
        </Box>
        <Box className={styles.boxWithMargin}>
          <Box className={styles.escribenosContainer}>
            <Typography className={styles.whiteText}>
              Escribenos a encontacto@villanueva.com.ar
            </Typography>
          </Box>
          <Box className={styles.whatsappButtonContainer}>
            <Box 
              className={styles.whatsappButton} 
              onClick={() => window.open(whatsappChatUrl, '_blank') }
            >
              o contactanos por whatsapp
              <img width={20} style={{marginLeft: 10}} src={WhatsappIcon} />
            </Box>
          </Box>
          <Box className={styles.villanuevaIconFooterContainer}>
            <img src={VillanuevaIcon} />
          </Box>
        </Box>
      </Box> */}
      {/* <NewClientsPopupBackground /> s */}
    </Dialog>
  )
}